
import { Poll } from '@/types/poll';
import { transformSupabasePollToPoll } from '@/utils/polls/pollDataTransformers';
import { useCollectionRealtime } from '../realtime/useCollectionRealtime';

/**
 * Hook to set up real-time subscription for polls updates using Universal Real-time Manager
 * @param setPolls Function to update polls state
 * @param effectiveCountryCode The country code to filter by
 */
export const usePollRealtime = (
  setPolls: React.Dispatch<React.SetStateAction<Poll[]>>,
  effectiveCountryCode?: string
) => {
  const { isConnected, connectionStatus } = useCollectionRealtime(
    'polls',
    {
      countryCode: effectiveCountryCode,
      status: 'live'
    },
    {
      onItemAdded: (payload) => {
        console.log('Adding new poll to state:', payload);
        // Check if this new poll matches our current filter
        const newPoll = payload;
        const shouldInclude = 
          newPoll.status === 'live' && 
          (!effectiveCountryCode || 
           newPoll.country_code === effectiveCountryCode || 
           newPoll.country_code === null);
          
        if (shouldInclude) {
          const transformedPoll = transformSupabasePollToPoll(newPoll);
          setPolls(currentPolls => {
            // Avoid duplicate polls by checking if it already exists
            if (currentPolls.some(p => p.id === transformedPoll.id)) {
              return currentPolls;
            }
            return [transformedPoll, ...currentPolls];
          });
        }
      },
      
      onItemUpdated: (payload) => {
        console.log('Updating existing poll:', payload);
        setPolls(currentPolls => 
          currentPolls.map(poll => 
            poll.id === payload.id 
              ? transformSupabasePollToPoll(payload) 
              : poll
          )
        );
      },
      
      onItemRemoved: (itemId) => {
        console.log('Removing deleted poll:', itemId);
        setPolls(currentPolls => 
          currentPolls.filter(poll => poll.id !== itemId)
        );
      },
      
      onError: (error) => {
        console.error('Poll real-time error:', error);
      }
    },
    true // Always enabled
  );

  return {
    isConnected,
    connectionStatus
  };
};
